var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st1 {\n        fill: currentColor;\n        stroke: none;\n        stroke-width: 1px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15,29c-.3304,0-.6356-.17453-.8036-.45889l-1.39098-2.35293c-2.86907-4.85053-5.57916-9.43196-6.50004-11.28027-.64898-1.33062-.97627-2.75396-.97627-4.23733.00031-5.33244,4.33844-9.67058,9.67089-9.67058,5.33276,0,9.67089,4.33813,9.67089,9.67058,0,1.48213-.32698,2.90547-.97191,4.22987-.00653.01307-.01307.02582-.0196.03858-.93551,1.86822-3.63129,6.42569-6.48449,11.24947l-1.39129,2.35293c-.16769.28405-.4732.45858-.8036.45857ZM15,2.86667c-4.30329,0-7.80391,3.50093-7.80391,7.80391,0,1.19716.26351,2.34547.78338,3.41258.88729,1.77987,3.70502,6.5436,6.42973,11.14991l.5908.99929.588-.99431c2.72627-4.60849,5.54493-9.37409,6.43595-11.16236.00373-.00684.00716-.014.01089-.02084.51084-1.05964.76969-2.198.76969-3.38396-.00031-4.30329-3.50124-7.80422-7.80453-7.80422Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.54865,8.01532c0,1.9599-1.58875,3.54871-3.54865,3.54871s-3.54865-1.58881-3.54865-3.54871h-1.29022v4.63684h9.67773v-4.63684h-1.29022Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkMapIcon);
export default __webpack_public_path__ + "static/media/ParkMapIcon.8c33dd3c524b6da8617921f2f8bd004e.svg";
export { ForwardRef as ReactComponent };